module.exports = __webpack_public_path__ + "static/img/areaA-5.f89bb27.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-5.png
// module id = 943
// module chunks = 1